import { SegmentField } from 'util/formatters/formatSegment';
import useAuth from 'core/hooks/useAuth';

const useSegmentField = () => {
  const { isHealthcareEnabled } = useAuth();
  const serviceRecipient = SegmentField.serviceRecipient.Singular();
  const serviceProvider = SegmentField.serviceProvider.Singular();
  const client = SegmentField.client.Singular();
  const service = SegmentField.service.Singular();
  const priceTable = SegmentField.priceTable.Singular();
  const record = SegmentField.record.Singular();
  const serviceRecipients = SegmentField.serviceRecipient.Plural();
  const serviceProviders = SegmentField.serviceProvider.Plural();
  const clients = SegmentField.client.Plural();
  const services = SegmentField.service.Plural();
  const priceTables = SegmentField.priceTable.Plural();
  const records = SegmentField.record.Plural();

  return {
    serviceRecipient,
    serviceProvider,
    client,
    service,
    priceTable,
    record,
    serviceRecipients,
    serviceProviders,
    clients,
    services,
    priceTables,
    records,
    isHealthcareEnabled
  };
};

export default useSegmentField;
